/*
 * Module for the fund picker control
*/
rs.module("ui/controls/fund-picker",

    [],

    function () {

        var _jsSelectors;
        var _cssClasses;

        var _menuToggle;
        var _fundMenu;

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, disabled) {

            // Only hook up listeners if control is not disabled
            if (!JSON.parse(disabled)) {
                _jsSelectors = jsSelectors;
                _cssClasses = cssClasses;

                _menuToggle = $.js(_jsSelectors.menuToggle);
                _fundMenu = $.js(_jsSelectors.fundMenu);

                // Show/hide menu when toggle has focus
                _menuToggle.focus(function () { toggleMenu(_fundMenu, true); });
                _menuToggle.blur(function () { toggleMenu(_fundMenu, false); });

                var fundLinks = _fundMenu.js(_jsSelectors.fundLink, { multiple: true });

                // Due to the order event handlers get executed, the blur event on the toggle fires before the click event of the menu links.
                // Because of this, the blur handler ends up hiding the menu before the click event fires, which results in clicking a link doing nothing.
                // However, since the mousedown event fires just before the blur event, we are able to suppress the default behavior of hiding the menu on blur.
                // Then, when the click event fires, we will hide the menu at that point
                fundLinks.mousedown(event, function () { event.preventDefault(); });

                // Update toggle text with the new fund name when a new fund is selected
                fundLinks.click(event, function () { setCurrentFundDisplay($(this).text()); });
            }
        }

        //
        // Toggle the visibilty of the menu
        //
        function toggleMenu(menu, visible) {
            menu.toggleClass(_cssClasses.visible, visible);
        }

        //
        // Display the new fund and hide the menu
        //
        function setCurrentFundDisplay(fundName) {
            _menuToggle.js(_jsSelectors.toggleText).text(fundName);
            _menuToggle.blur();
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);